import React from "react";
import {Button} from "reactstrap";
import assets from "../../util/assets";

const ButtonDesign = ({btId, btName, btColor, btDisable, btClass, btStyle, children, onclickFunction,has_notification}) => {
    const btnId = btId ? btId : "";
    const btnStyle = btStyle ? btStyle : "";

    return (
        <Button
            id={btnId}
            color={btColor}
            className={btClass}
            style={{btnStyle}}
            disabled={btDisable}
            onClick={() => onclickFunction()}
        >
            {children}
            {btName ? btName : ""}
            {
                has_notification && <img alt="has notification" className="has-notification" src={assets.broadcast.top_section.has_notification}/>
            }
        </Button>
    );
};

export default ButtonDesign;
